import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import MainLayout from "@/components/MainLayout";
import AdminLayout from "@/components/AdminLayout";
import Home from "@/pages/Home";
import Tasks from "@/pages/Tasks";
import TaskDetails from "@/pages/TaskDetails";
import Payments from "@/pages/Payments";
import Account from "@/pages/Account";
import Support from "@/pages/Support";
import SubmitTask from "@/pages/user/SubmitTask";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminTasks from "@/pages/admin/AdminTasks";
import AdminSubmissions from "@/pages/admin/AdminSubmissions";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminRewards from "@/pages/admin/AdminRewards";
import AdminWithdrawals from "@/pages/admin/AdminWithdrawals";
import AdminExports from "@/pages/admin/AdminExports";
import AdminSupport from "@/pages/admin/AdminSupport";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<MainLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/tasks" element={<Tasks />} />
            <Route path="/tasks/:code" element={<TaskDetails />} />
            <Route path="/support" element={<Support />} />
            <Route path="/submit/:code" element={<ProtectedRoute role="user"><SubmitTask /></ProtectedRoute>} />
            <Route path="/payments" element={<ProtectedRoute role="user"><Payments /></ProtectedRoute>} />
            <Route path="/account" element={<ProtectedRoute role="user"><Account /></ProtectedRoute>} />
            <Route path="/dashboard" element={<Navigate to="/" replace />} />
            <Route path="/wallet" element={<Navigate to="/payments" replace />} />
            <Route path="/submissions" element={<Navigate to="/account" replace />} />
            <Route path="/profile" element={<Navigate to="/account" replace />} />
            <Route path="/how-it-works" element={<Navigate to="/support" replace />} />
          </Route>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route element={<ProtectedRoute role="admin"><AdminLayout /></ProtectedRoute>}>
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/tasks" element={<AdminTasks />} />
            <Route path="/admin/submissions" element={<AdminSubmissions />} />
            <Route path="/admin/users" element={<AdminUsers />} />
            <Route path="/admin/rewards" element={<AdminRewards />} />
            <Route path="/admin/withdrawals" element={<AdminWithdrawals />} />
            <Route path="/admin/exports" element={<AdminExports />} />
            <Route path="/admin/support" element={<AdminSupport />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
